export function ProductBadge({ type, children }) {
  const styles = {
    new: "bg-white text-neutral-950",
    sale: "bg-red-600 text-white",
    bestSeller: "bg-neutral-950 text-white",
    soldOut: "bg-neutral-200 text-neutral-600",
  };

  return (
    <span
      className={[
        "inline-flex rounded-full px-3 py-1 text-[11px] font-bold uppercase tracking-[0.16em] shadow-sm",
        styles[type] || styles.new,
      ].join(" ")}
    >
      {children}
    </span>
  );
}